import { render } from "./ScreenSlide.vue?vue&type=template&id=da288260&scoped=true&ts=true"
import script from "./ScreenSlide.vue?vue&type=script&lang=ts"
export * from "./ScreenSlide.vue?vue&type=script&lang=ts"

import "./ScreenSlide.vue?vue&type=style&index=0&id=da288260&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da288260"]])

export default __exports__